enum RootStatus {
    UNLOADED = 'UNLOADED',
    LOADING = 'LOADING',
    LOADED = 'LOADED',
    AUTHENTICATED = 'AUTHENTICATED'
}

export default RootStatus;
